import { render, staticRenderFns } from "./InformeAuditoriaActionButton.vue?vue&type=template&id=672fd872&"
import script from "./InformeAuditoriaActionButton.vue?vue&type=script&lang=js&"
export * from "./InformeAuditoriaActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCardActions,
  VIcon,
  VSpacer,
  VTooltip,
})
